import React, { Component } from 'react';
import moment from 'moment';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  DateOfBirthInput,
  GenericTextArea,
} from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import {
  DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH,
  DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH,
  MAXIMUM_DISPUTE_THRESHOLD_DAYS,
  PAGE_MAXIMUM_DISPUTE_THRESHOLD,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
  PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER,
} from '../../../constants/FraudAndDisputeConstants';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export class DescribeTheTravelBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expectedDepartureDate:
        FraudAndDisputeStore.getExpectedTravelDepartureDate(),
      expectedReturnDate: FraudAndDisputeStore.getExpectedTravelReturnDate(),
      descriptionText: FraudAndDisputeStore.getTravelDescriptionText(),
      expectedDepartureDateError: false,
      expectedReturnDateError: false,
      descriptionTextError: false,
      descriptionTextValidationMessage:
        props.content.describeTravelBookingValidationMessage,
      expectedDepartureDateValidationMessage:
        props.content.departureDateValidationMessage,
      expectedReturnDateValidationMessage:
        props.content.returnDateValidationMessage,
    };
  }

  onContinueClick = () => {
    const { expectedDepartureDate, expectedReturnDate, descriptionText } =
      this.state;
    const { content, setPage } = this.props;

    !expectedDepartureDate &&
      this.setState({
        expectedDepartureDateError: true,
        expectedDepartureDateValidationMessage:
          content.departureDateValidationMessage,
      });

    !expectedReturnDate &&
      this.setState({
        expectedReturnDateError: true,
        expectedReturnDateValidationMessage:
          content.returnDateValidationMessage,
      });

    (!descriptionText || (descriptionText && !descriptionText.trim().length)) &&
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.describeTravelBookingValidationMessage,
      });

    if (
      expectedDepartureDate &&
      expectedReturnDate &&
      moment(expectedReturnDate).isSameOrAfter(expectedDepartureDate) &&
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      /**
       * Happy path - completed validation.
       * TODOxVM Simplify this methods logic
       */

      if (
        moment().diff(expectedDepartureDate, 'day') >
        MAXIMUM_DISPUTE_THRESHOLD_DAYS
      ) {
        setPage(PAGE_MAXIMUM_DISPUTE_THRESHOLD);
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_dispute_maximum_days_threshold,
          config.analytics.analytics_action_button_click
        );
        return;
      }

      this.setState({
        expectedDepartureDateError: false,
        expectedReturnDateError: false,
        descriptionTextError: false,
      });
      FraudAndDisputeActionCreator.setExpectedTravelDepartureDate(
        expectedDepartureDate
      );
      FraudAndDisputeActionCreator.setExpectedTravelReturnDate(
        expectedReturnDate
      );
      FraudAndDisputeActionCreator.setTravelDescriptionText(descriptionText);
      setPage(PAGE_WHAT_HAPPENED_WHEN_CONTACTED_THE_SELLER);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_describe_the_travel,
        config.analytics.analytics_action_button_click
      );
      return;
    }
    if (moment(expectedDepartureDate).isAfter(expectedReturnDate)) {
      this.setState({
        expectedDepartureDateError: true,
        expectedDepartureDateValidationMessage:
          content.departureDateValidationMessage2,
        expectedReturnDateError: true,
        expectedReturnDateValidationMessage:
          content.returnDateValidationMessage2,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length >=
        DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH &&
      descriptionText.trim().length <=
        DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: false,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length < DESCRIPTION_TEXT_MINIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.goodsDescriptionTextValidationMessage2,
      });
    }
    if (
      descriptionText &&
      descriptionText.trim().length > DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH
    ) {
      this.setState({
        descriptionTextError: true,
        descriptionTextValidationMessage:
          content.travelDescriptionTextValidationMessage3,
      });
    }
    if (
      expectedDepartureDate &&
      expectedReturnDate &&
      moment(expectedDepartureDate).isSameOrBefore(expectedReturnDate)
    ) {
      this.setState({
        expectedDepartureDateError: false,
        expectedReturnDateError: false,
      });
    }
  };
  render() {
    const { content, setPage } = this.props;
    const {
      expectedDepartureDate,
      expectedReturnDate,
      descriptionText,
      expectedDepartureDateError,
      expectedReturnDateError,
      descriptionTextError,
      descriptionTextValidationMessage,
      expectedDepartureDateValidationMessage,
      expectedReturnDateValidationMessage,
    } = this.state;
    return (
      <div>
        <ApplicationFormShell
          leftSidebar={
            <DisputeProgressComponent
              items={content.disputeProgressStepperItems}
              currentId="3"
            />
          }
        >
          <PageHeading>{content.describeTheTravelBooking}</PageHeading>
          <StandardBody>
            <strong>{content.describeTheTravelBookingSubText}</strong>
          </StandardBody>
          <div className="web-ui-components">
            <GenericFieldWrapper
              titleText={content.expectedDepartureDate}
              description={content.expectedDepartureDateSubText}
              validationMessage={
                expectedDepartureDateError &&
                expectedDepartureDateValidationMessage
              }
            >
              {/* @todo - This should be replaced once the generic DD-MM-YYYY component is available in the web ui lib */}

              <DateOfBirthInput
                id="expected-departure-date"
                onChange={(obj) =>
                  this.setState({
                    expectedDepartureDate: obj.value,
                  })
                }
                value={expectedDepartureDate}
              />
            </GenericFieldWrapper>
            <GenericFieldWrapper
              titleText={content.expectedReturnDate}
              description={content.expectedReturnDateSubText}
              validationMessage={
                expectedReturnDateError && expectedReturnDateValidationMessage
              }
            >
              {/* @todo - This should be replaced once the generic DD-MM-YYYY component is available in the web ui lib */}

              <DateOfBirthInput
                id="expected-return-date"
                onChange={(obj) =>
                  this.setState({
                    expectedReturnDate: obj.value,
                  })
                }
                value={expectedReturnDate}
              />
            </GenericFieldWrapper>
            <GenericFieldWrapper
              titleText={content.describeTheTravelBooking}
              validationMessage={
                descriptionTextError && descriptionTextValidationMessage
              }
            >
              <GenericTextArea
                id="travel-description-text"
                characterWidth={40}
                maximumCharacters={DESCRIPTION_TEXT_MAXIMUM_CHARACTERS_LENGTH}
                hideCharacterCount
                onChange={({ value }) => {
                  this.setState({ descriptionText: value });
                }}
                value={descriptionText}
              />
            </GenericFieldWrapper>
          </div>
          <div className="button-group">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={() => {
                setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
              }}
            />
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={this.onContinueClick}
            />
          </div>
        </ApplicationFormShell>
      </div>
    );
  }
}
